export default __webpack_public_path__ + "static/media/conor-new.97f436a8.jpeg";